import React from "react";
import * as constants from "../constants";
import { t } from "i18next";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useCountryPrefix } from "../routes/useCountryPrefix"; // adjust path
import CustomImageComponent from "./CustomImageComponent";

const PropertyFilter = () => {
  let listingApiUrl = process.env.REACT_APP_API_URL;

  const { i18n } = useTranslation();
  const countryPrefix = useCountryPrefix();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  let PropertyTypes = searchParams.get('pt');
  PropertyTypes = PropertyTypes === null ? "" : PropertyTypes
  // const pt = Object.keys(constants.defaultPropertyType).filter(id => PropertyTypes.includes(constants.defaultPropertyType[id].label)).map(id => Number(id))
  const pt = Object.keys(constants.defaultPropertyType).filter(id => PropertyTypes.split(",").includes(constants.defaultPropertyType[id].label)).map(id => Number(id));

  const clickHandle = (id) => {
    PropertyTypes = PropertyTypes === "" ? id : PropertyTypes + "," + id
    resirection(PropertyTypes)
  }

  const removePropertyTypeClick = (key) => {

    let pType = searchParams.get('pt')?.split(',') || [];
    pType = pType.filter(type => type !== key);

    PropertyTypes = pType.join(',')
    resirection(PropertyTypes)

  }

  const resirection = (url) => {

    const isArabic = i18n.language === "ar";;
    const language = isArabic ? "/ar" : "";
    let baseUrl = window.location.origin + "/" + countryPrefix + language + "/search"
    const finalUrl = url === "" ? baseUrl : `${baseUrl}?pt=${url}`;
    window.location.href = finalUrl
  }
  return (
    <>
      <section className="category-list-section">
        <div className="container">
          <ul>
            {Object.entries(constants.defaultPropertyType).map(([key, item]) => (
              <li className={pt?.includes(Number(key)) ? "active" : ""} key={key} onClick={pt?.includes(Number(key)) ? undefined : () => clickHandle(item.label)}
              >
                <span className="clear-icon" onClick={() => removePropertyTypeClick(item.label)}>
                  <i className="fas fa-times"></i>
                </span>
                <CustomImageComponent
                  src={item.image}
                  alt={item.label}
                  className={"img-fluid"}
                />
                <p>{t(item.label)}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </>
  );
};

export default PropertyFilter;
